import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarditNestingReport
  from '../../components/CarditNestingReport';
import CarditNestingLocationReportMode from './CarditNestingLocationReportMode';
import {
  deepClone,
  getLeafColumns,
  getPropertyValueByPath,
  setPropertyValueByPath,
} from '../../../../../react-table/helpers/utils';
import {
  COLUMN_ACCESSOR_RECEPTACLES_TOTAL,
  getGeneratedOnDateTime,
  getIsLoading,
  getFilteredAndSortedData, getIsFiltered,
  getOriginalGrandTotal,
  PROPERTY_ORIGINAL_GRAND_TOTAL, getColumns,
} from '../redux/selectors/CarditNestingLocationSelectors';
import { getReportMode } from '../../../../common/redux/selectors/ReportsSelectors';
import {
  changeReportFiltering,
  changeReportMode,
  changeReportSorting,
} from '../../../../common/redux/actions/ReportsActions';

const MODE_TABS = [
  { value: CarditNestingLocationReportMode.percentage, label: '%' },
  { value: CarditNestingLocationReportMode.number, label: '#' },
];

class CarditNestingLocationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
      },
      sorting: {},
      filtering: {},
    });
  }

  onLocationReportSortedChange = (newSorted, column, shiftKey) => {
    this.props.changeReportSorting({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
      },
      sorting: {
        newSorted,
        column,
        shiftKey,
      },
    });
  };

  onLocationReportFilteredChange = (column, value) => {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
      },
      filtering: {
        appliedFilters: column,
        appliedColumn: value,
      },
    });
  };

  getColumnsWithOriginalGrandTotal() {
    const { columns } = this.props;

    const transformedColumns = deepClone(columns);

    const leafColumns = getLeafColumns(transformedColumns);
    const columnWithGrandTotalLink =
      leafColumns.find(column => column.accessor === COLUMN_ACCESSOR_RECEPTACLES_TOTAL);

    const originalGrandTotal =
      getPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL);
    if (!originalGrandTotal && this.props.isFiltered && this.props.originalGrandTotal) {
      // eslint-disable-next-line max-len
      setPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL, this.props.originalGrandTotal);
    }

    return transformedColumns;
  }

  changeMode = (reportMode) => {
    this.props.changeReportMode({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_NESTING_LOCATION.id,
      },
      reportMode,
    });
  };

  render() {
    return (<CarditNestingReport
      reportId={ReportDefinitions.CARDIT_NESTING_LOCATION.id}
      columns={this.getColumnsWithOriginalGrandTotal.apply(this)}
      isLoading={this.props.isLoading}
      generatedOnDateTime={this.props.generatedDateTime}
      data={this.props.data}
      modeTabs={MODE_TABS}
      changeMode={this.changeMode}
      mode={this.props.mode}
      onSortedChange={this.onLocationReportSortedChange}
      onFilteredChange={this.onLocationReportFilteredChange}
    />);
  }
}

const mapStateToProps = state => ({
  data: getFilteredAndSortedData(state),
  generatedDateTime: getGeneratedOnDateTime(state),
  isLoading: getIsLoading(state),
  columns: getColumns(state),
  mode: getReportMode(state, ReportDefinitions.CARDIT_NESTING_LOCATION.id),
  isFiltered: getIsFiltered(state),
  originalGrandTotal: getOriginalGrandTotal.apply(this, [state]),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeReportMode,
    changeReportSorting,
    changeReportFiltering,
  }, dispatch);

CarditNestingLocationContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  changeReportMode: PropTypes.func,
  changeReportSorting: PropTypes.func,
  changeReportFiltering: PropTypes.func,
  mode: PropTypes.string,
  isFiltered: PropTypes.bool,
  originalGrandTotal: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarditNestingLocationContainer);
